import { trackError } from '../appError';
import { isOptionInstrumentString, parseInstrument } from '../instrumentUtils';
import type {
    ICellRendererFunc,
    ICellRendererParams,
    ValueFormatterFunc,
    ValueFormatterParams,
} from '@ag-grid-community/core';
import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';
import type { OptionInstrument } from '@thinkalpha/ui-types/types/instrument';

/** Framework-neutral instrument display used by both ag-grid and the ADR 0014 fast cell path. */
export const formatInstrumentValue = (value: unknown): string => {
    if (!value) return '';
    if (typeof value !== 'string' || !isOptionInstrumentString(value)) return String(value);

    try {
        const parsed = parseInstrument(value) as OptionInstrument;
        return `${parsed.underlyingInstrument.symbol} | ${parsed.expiry.toString()} | ${parsed.right === 'call' ? 'Call' : 'Put'} | $${parsed.strike}`;
    } catch (e) {
        // Do not throw if instrument is invalid - display original value
        if (e instanceof Error) {
            trackError(e, {
                extra: {
                    instrument: value,
                },
            });
        }
    }
    return value;
};

export const instrumentRenderer: ICellRendererFunc<Instrument> & ValueFormatterFunc<Instrument> = (
    params: ICellRendererParams<Instrument> | ValueFormatterParams<Instrument>,
) => {
    return formatInstrumentValue(params.value);
};
